import React, { useEffect, useState } from "react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import "./Ranking.css";

const Ranking = () => {
  const [topContributors, setTopContributors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopContributors = async () => {
      try {
        const usersQuery = query(
          collection(db, "users"),
          orderBy("commentCount", "desc"),
          limit(3)
        );
        const querySnapshot = await getDocs(usersQuery);
        const contributors = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTopContributors(contributors);
      } catch (error) {
        console.error("Error fetching top contributors:", error);
      }
    };

    fetchTopContributors();
  }, []);

  return (
    <div className="ranking-container">
      <h1 className="ranking-title">RANKING</h1>
      <div className="ranking-list">
        {topContributors.length > 0 ? (
          topContributors.map((user, index) => (
            <div key={user.id} className="ranking-card">
              <div className="ranking-position">#{index + 1}</div>
              <div className="ranking-info">
                <h2 className="nickname">{user.nickname}</h2>
                <p className="comment-count">댓글 수: {user.commentCount || 0}</p>
              </div>
            </div>
          ))
        ) : (
          <p className="no-contributors">아직 기여자가 없습니다.</p>
        )}
      </div>
    </div>
  );
};

export default Ranking;